import {
    orderQtyTranslationMap
} from 'SourceComponent/MyAccountOrderItemsTableRow/MyAccountOrderItemsTableRow.config';

export {
    orderQtyTranslationMap
};
